import React from 'react';
import axios from "axios";
import validator from 'validator';
import { Container, useMantineTheme, Box, SimpleGrid, Card, Button } from '@mantine/core';
import { notifications } from '@mantine/notifications';

import { useLoginContext } from "../../context/loginContext";

import { BE_API_AUTH, utils } from "../../utils/globalVariables";
import { regexNoSpace } from "../../utils/globalFunctions";

import ModalResponse from "../../components/general/ModalResponse";
import InputComponent from "../../components/general/InputComponent";

const AccountResetUsernamePassword = () => {

    const mountedRef = React.useRef(true);

    const theme = useMantineTheme();
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorSubmitReset: 'AccountResetUsernamePassword-4',
        successSubmitReset: 'AccountResetUsernamePassword-5',
    })

    const [data, setData] = React.useState({
        reset: {
            valueUsername: '',
            valueUsernameError: '',

            valuePassword: '',
            valuePasswordError: '',

            submitLoading: false
        },
        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const submitReset = () => {
        setData(d => ({ ...d, reset: { ...d.reset, valueUsernameError: '', valuePasswordError: '' } }));

        if (validator.isEmpty(data.reset.valueUsername, { ignore_whitespace: true })) {
            setData(d => ({ ...d, reset: { ...d.reset, valueUsernameError: 'Username Harus Diisi !' } }));
        } else if (!validator.isLength(data.reset.valueUsername, { min: utils.minCharUsername, max: utils.maxCharUsername })) {
            setData(d => ({ ...d, reset: { ...d.reset, valueUsernameError: `Username Diisi ${utils.minCharUsername + '-' + utils.maxCharUsername} Digit` } }));
        } else if (validator.isEmpty(data.reset.valuePassword, { ignore_whitespace: true })) {
            setData(d => ({ ...d, reset: { ...d.reset, valuePasswordError: 'Password Harus Diisi !' } }));
        } else if (!validator.isLength(data.reset.valuePassword, { min: utils.minCharPassword, max: utils.maxCharPassword })) {
            setData(d => ({ ...d, reset: { ...d.reset, valuePasswordError: `Password Diisi ${utils.minCharPassword + '-' + utils.maxCharPassword} Digit` } }));
        } else {
            setData(d => ({ ...d, reset: { ...d.reset, submitLoading: true } }));

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContext.syswebapp);
            formDT.append('username', data.reset.valueUsername);
            formDT.append('password', data.reset.valuePassword);

            axios({
                method: 'post',
                url: BE_API_AUTH + '/update_username_password',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, reset: { ...d.reset, submitLoading: false } }));

                if (response.data.flag_status === 'isset') {
                    setData(d => ({
                        ...d,
                        reset: {
                            ...d.reset,
                            valueUsername: '',
                            valuePassword: ''
                        }
                    }));

                    notifications.show({
                        id: notificationId.current.successSubmitReset,
                        title: utils.notification.success.caption,
                        message: 'Berhasil Submit Data.',
                        color: utils.notification.success.color,
                        icon: utils.notification.success.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'duplicate-username') {
                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: false,
                            content: `Username ${response.data.suspect} sudah pernah didaftarkan. Coba pilihan lain.`,
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'error') {
                    notifications.show({
                        id: notificationId.current.errorSubmitReset,
                        title: utils.notification.warning.caption,
                        message: response.data.pesan,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContext(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContext(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, reset: { ...d.reset, submitLoading: false } }));

                notifications.show({
                    id: notificationId.current.errorSubmitReset,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            })
        }
    }

    return (
        <React.Fragment>
            <Container fluid>
                <SimpleGrid
                    cols={1}
                    spacing='sm'
                    mt='2rem'
                    breakpoints={[
                        { minWidth: 'xl', cols: 3, spacing: 'sm' },
                        { minWidth: 'lg', cols: 3, spacing: 'sm' },
                        { minWidth: 'md', cols: 2, spacing: 'sm' },
                        { minWidth: 'sm', cols: 1, spacing: 'sm' },
                        { minWidth: 'xs', cols: 1, spacing: 'sm' },
                    ]}
                >
                    <Box>
                        <Card
                            shadow=''
                            radius="sm"
                            withBorder={true}
                            mb='2rem'

                            style={{
                                borderColor: theme.colorScheme === 'light' ? theme.colors.gray[2] : theme.colors.dark[7],
                                backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[7],
                                overflow: 'unset',
                            }}
                        >
                            <Card.Section p='sm'>
                                <InputComponent
                                    stateId='reset-username'
                                    stateWithAsterisk={true}
                                    stateLabelFullWidth={true}
                                    stateLabel={`Username Baru (${utils.minCharUsername}-${utils.maxCharUsername} digit)`}
                                    stateDescription=''
                                    statePlaceHolder='Username'
                                    stateReadOnly={false}
                                    stateMB='1.5rem'
                                    stateValue={data.reset.valueUsername}
                                    stateError={data.reset.valueUsernameError}
                                    fnOnChange={(e) => setData(d => ({ ...d, reset: { ...d.reset, valueUsername: regexNoSpace(e.target.value) } }))}
                                />

                                <InputComponent
                                    stateId='reset-password'
                                    stateWithAsterisk={true}
                                    stateLabelFullWidth={true}
                                    stateLabel={`Password Baru (${utils.minCharUsername}-${utils.maxCharUsername} digit)`}
                                    stateDescription=''
                                    statePlaceHolder='Password'
                                    stateReadOnly={false}
                                    stateValue={data.reset.valuePassword}
                                    stateError={data.reset.valuePasswordError}
                                    fnOnChange={(e) => setData(d => ({ ...d, reset: { ...d.reset, valuePassword: regexNoSpace(e.target.value) } }))}
                                />

                                <Button
                                    mt='1rem'
                                    size='xs'
                                    loading={data.reset.submitLoading}
                                    onClick={submitReset}
                                >
                                    Reset Username & Password
                                </Button>
                            </Card.Section>
                        </Card>
                    </Box>
                </SimpleGrid>
            </Container>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />
        </React.Fragment>
    )
}

export default AccountResetUsernamePassword;